import { createI18n } from 'vue-i18n'
import zhTW from '@/locales/zh-tw.json'
import zhCN from '@/locales/zh-cn.json'
import en from '@/locales/en.json'

const savedLanguage = localStorage.getItem('language') || 'zh-TW'

export const i18n = createI18n({
  legacy: false, 
  locale: savedLanguage,
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'en': en
  }
})

export function setLanguage(lang: string) {
  i18n.global.locale.value = lang as any
  localStorage.setItem('language', lang)
  // Optionally reload to fetch language specific data from API if needed
  // window.location.reload()
}

export function getLocaleString(obj: any, prefix: string): string {
  if (!obj) return '';
  // Support vue-i18n global locale ref
  const lang = typeof i18n.global.locale.value === 'string' 
    ? i18n.global.locale.value 
    : (i18n.global.locale as any).value;
    
  // Ensure the first letter of prefix is capitalized for the property name
  const capitalizedPrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1);
  
  if (lang === 'en') return obj[`${prefix}En`] || obj[`${capitalizedPrefix}En`] || '';
  if (lang === 'zh-CN') return obj[`${prefix}ZhCn`] || obj[`${capitalizedPrefix}ZhCn`] || '';
  
  return obj[`${prefix}ZhTw`] || obj[`${capitalizedPrefix}ZhTw`] || '';
}
